import { render, staticRenderFns } from "./JamesArticle.vue?vue&type=template&id=7ad5aaa2&"
import script from "./JamesArticle.vue?vue&type=script&lang=js&"
export * from "./JamesArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports